import { gql } from '../../../../../types/__codegen__/sanity';

export const GET_PERK_DETAIL = gql(`
  query GetPerk($id: ID!) {
    allMemberPerk(where: { _id: { eq: $id } }) {
      _id
      name
      identifier {
        ...SlugFields
      }
      slogan
      descriptionRaw
      descriptionTeaser
      imageObject {
        ...ImageObjectFields
      }
      urlObject {
        ...UrlObjectFields
      }
      disclaimer {
        contentRaw
        symbol
      }
      service {
        ...ContentTileFields
        imageObject {
          ...ImageObjectFields
        }
      }
      offeredBy {
        name
        logo {
          asset {
            _id
            url
          }
        }
      }
      category
      discountCodes {
        code {
          current
        }
        descriptionRaw
      }
      termsAndConditionsRaw
      release {
        ...ReleaseFields
      }
      magicLinkCode {
        current
      }
      metadataObject {
        title: name
        description: descriptionRaw
      }
    }
  }
`);
